export default "__VITE_ASSET__LnPmWuoJ__"